import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <>
      <style>{`
        [data-sonner-toast] svg {
          color: #22c55e !important;
          fill: #22c55e !important;
        }
        [data-sonner-toast][data-type="success"] svg {
          color: #22c55e !important;
          fill: #22c55e !important;
        }
        [data-sonner-toast][data-type="error"] svg {
          color: #ef4444 !important;
          fill: #ef4444 !important;
        }
      `}</style>
      <Sonner
        theme="light"
        className="toaster group"
        toastOptions={{
          style: {
            background: 'white',
            color: 'black',
            border: '1px solid #e5e7eb',
          },
          classNames: {
            toast: "!bg-white !text-black border border-gray-200 shadow-lg",
            description: "!text-gray-600",
            success: "!bg-white !text-black border-l-4 !border-l-green-500",
            error: "!bg-white !text-black border-l-4 !border-l-red-500",
          },
        }}
        {...props} />
    </>
  );
}

export { Toaster, toast }
